/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeV6Schema } from '../getPublicChallengeBySlugV6/get-public-challenge-by-slug-v6-response';
import { publicChallengeClipItemV2Schema } from '../listPublicChallengeClipsBySlugV2/list-public-challenge-clips-by-slug-v2-response';
import { publicChallengeTranslationItemSchema } from '../listPublicChallengeTranslationsBySlugV1/list-public-challenge-translations-by-slug-v1-response';

export const challengeVsBundleMemberV1Schema = z.object({
  challenge: challengeV6Schema,
  translations: z.array(publicChallengeTranslationItemSchema),
  clips: z.array(publicChallengeClipItemV2Schema),
});

export type IChallengeVsBundleMemberV1 = z.infer<typeof challengeVsBundleMemberV1Schema>;

export const challengeVsBundleV1Schema = z.object({
  members: z.array(challengeVsBundleMemberV1Schema),
});

export type IChallengeVsBundleV1 = z.infer<typeof challengeVsBundleV1Schema>;

export const getChallengeVsBundleV1ResponseSchema = createApiResponseSchema(
  challengeVsBundleV1Schema,
) as z.ZodSchema<IAPI<IChallengeVsBundleV1>>;

export type IGetChallengeVsBundleV1Response = IAPI<IChallengeVsBundleV1>;
